/* eslint-disable @typescript-eslint/no-explicit-any */

const compareValuesForKey = (
  key: string,
  obj1: Record<string, any>,
  obj2: Record<string, any>
): Record<string, any> | null => {
  const value1 = obj1[key];
  const value2 = obj2[key];

  if (value1 === null || value1 === undefined) {
    if (value2 === null || value2 === undefined) {
      return null; // Both are null or undefined, no difference
    } else {
      return { [key]: { oldValue: null, newValue: value2 } }; // obj1 is null/undefined, obj2 has a value
    }
  } else if (value2 === null || value2 === undefined) {
    return { [key]: { oldValue: value1, newValue: null } }; // obj1 has a value, obj2 is null/undefined
  } else {
    // Both have values, compare them
    if (JSON.stringify(value1) !== JSON.stringify(value2)) {
      return { [key]: { oldValue: value1, newValue: value2 } }; // Values are different
    } else {
      return null; // Values are the same
    }
  }
};

export const computeDiffForCohortBuilderItem = (
  obj1: Record<string, any>,
  obj2: Record<string, any>
): boolean => {
  const diff: Record<string, any> = {};

  for (const key in obj1) {
    if (key === 'changeStatus') continue; // Skip if key is 'changeStatus'

    const result = compareValuesForKey(key, obj1, obj2);
    if (result) {
      diff[key] = result[key];
    }
  }

  for (const key in obj2) {
    if (key === 'changeStatus') continue; // Skip if key is 'changeStatus'

    if (!obj1[key]) {
      const result = compareValuesForKey(key, obj1, obj2);
      if (result) {
        diff[key] = result[key];
      }
    }
  }

  return Object.keys(diff).length > 0;
};
